import { Locale } from 'softcat:config/locale.ts';
import { UserPreferencesConfig } from 'softcat:config/user-preferences.ts';

const getMessages = async (locale: Locale): Promise<Record<string, string>> => {
    const response = await fetch(`${import.meta.env.BASE_URL}locales/${locale}.json?v=${import.meta.env.APP_VERSION}`);

    const messages = await response.json();

    localStorage.setItem(UserPreferencesConfig.LanguageStorageKey, locale);

    return messages;
};

export const LocaleService = {
    getMessages,
};
